<template>
  <div class="content">
    <div class="text-center loading-prepare" v-if="isLoading">
      <img
        src="@/assets/images/loading-d-dots.gif"
        alt="loading"
        class="loading-icon"
      />
    </div>
    <div v-else-if="voucherList.length > 0 && !isLoading">
      <div v-for="(i, index) in voucherList" :key="index">
        <VoucherCard
          :detail="i"
          class="my-3"
          @showConfirmVoucherReply="showConfirmVoucherReply"
        />
      </div>
    </div>
    <div v-else class="d-flex justify-content-center h-100 bg-white pt-3">
      {{ $t("noData") }}
    </div>

    <ChatboxModalConfirmVoucherReply
      ref="ChatboxModalConfirmVoucherReply"
      @confirm="clickSelectTextReply"
    />
  </div>
</template>

<script>
import VoucherCard from "./VoucherCard.vue";
import ChatboxModalConfirmVoucherReply from "@/components/chat/chatBox/modal/ChatboxModalConfirmVoucherReply";
import { EventBus } from "@/helpers/event";
import { MESSAGE_TYPES } from "@/helpers/constants.js";
export default {
  props: {
    status: {
      type: String,
      default: "all"
    }
  },
  components: {
    VoucherCard,
    ChatboxModalConfirmVoucherReply
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      isMore: false,
      isLoading: false,
      voucherList: []
    };
  },
  mounted() {
    this.fetchVoucher();
  },
  methods: {
    async clickSelectTextReply(voucher) {
      let dataSend = {
        text: voucher.voucherId,
        imageUrl: "",
        attachments: null,
        isReply: false,
        replyMessageId: "",
        custom: {
          voucherId: voucher.voucherId,
          voucher: voucher.voucherName,
          voucherCode: voucher.voucherCode,
          isAdmin: voucher.isAdmin,
          percentage: voucher.percentage,
          minPrice: voucher.minBasketPrice,
          discountAmount: voucher.discountAmount,
          endAt: voucher.endAt
        }
      };
      EventBus.$emit("send-message-custom", {
        data: dataSend,
        type: MESSAGE_TYPES.Voucher
      });
    },
    showConfirmVoucherReply(detail) {
      this.$refs.ChatboxModalConfirmVoucherReply.show(detail);
    },
    async fetchVoucher() {
      try {
        this.isLoading = true;
        const query = `?customerId=${this.$store.state.chatUserGUIDSelected}&currentPage=${this.currentPage}&limit=${this.pageSize}&status=${this.status}`;
        let result = await fetch(`${this.$shopeeUrl}/shopee/voucher${query}`, {
          method: "GET",
          headers: new Headers(this.$headersChat)
        });

        let resultJson = await result.json();
        this.voucherList = resultJson.detail.voucherList ?? [];
        this.isMore = resultJson.detail.more;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  overflow: auto;
  width: 100%;
  height: calc(100dvh - 260px);
  // padding: 20px 0px;
  background-color: #f6f6f6;

  &::-webkit-scrollbar {
    width: 0.35rem;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(177, 175, 175, 0.3);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }

  div:last-child {
    margin-bottom: 30px;
  }
}
</style>
